export default __webpack_public_path__ + "static/media/black_friday_2025_teaser_dashboard.3b641a09.png";